import { useState, useEffect } from 'react';
import { useApp } from '../context/AppContext';
import { questions } from '../data/questions';
import StarField from '../components/StarField';
import styles from './Quiz.module.css';

export default function Quiz() {
  const { state, dispatch } = useApp();
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [disturbed, setDisturbed] = useState(false);
  const [exiting, setExiting] = useState(false);
  const [hoveredIndex, setHoveredIndex] = useState(null);

  const question = questions[state.currentQuestion];
  const progress = ((state.currentQuestion + 1) / questions.length) * 100;

  useEffect(() => {
    setSelectedIndex(null);
    setExiting(false);
    setHoveredIndex(null);
  }, [state.currentQuestion]);

  const handleSelect = (option, index) => {
    if (selectedIndex !== null) return;
    
    setSelectedIndex(index);
    setDisturbed(true);
    setTimeout(() => setDisturbed(false), 300);

    setTimeout(() => {
      setExiting(true);
      setTimeout(() => {
        dispatch({ type: 'ANSWER_QUESTION', payload: { ...option, optionIndex: index } });
        if (state.currentQuestion >= questions.length - 1) {
          dispatch({ type: 'SET_PAGE', payload: 'radarResult' });
        }
      }, 600);
    }, 700);
  };

  if (!question) return null;

  return (
    <div
      className={`${styles.container} ${disturbed ? styles.disturbance : ''} ${exiting ? styles.exiting : ''}`}
    >
      <StarField density={150} speed={0.3} />
      
      {/* 进度条 */}
      <div className={styles.progressBar}>
        <div className={styles.progressFill} style={{ width: `${progress}%` }} />
        <span className={styles.progressText}>{state.currentQuestion + 1} / {questions.length}</span>
      </div>

      {/* 装饰元素 */}
      <div className={styles.decorLeft} />
      <div className={styles.decorRight} />
      <div className={styles.decorTopRight} />
      <div className={styles.decorBottomLeft} />
      <div className={styles.orbitRing1} />
      <div className={styles.orbitRing2} />
      
      {/* 星球装饰 */}
      <img src="/images/saturn.png" alt="" className={styles.planetLeft} />
      <img src="/images/plant-glow.png" alt="" className={styles.planetRight} />
      <img src="/images/small-planet.png" alt="" className={styles.planetSmall1} />
      <img src="/images/small-planet.png" alt="" className={styles.planetSmall2} />
      
      {/* 发光点 */}
      <div className={styles.glowDot1} />
      <div className={styles.glowDot2} />
      <div className={styles.glowDot3} />
      <div className={styles.glowDot4} />
      
      {/* 连接线 */}
      <div className={styles.connectLine1} />
      <div className={styles.connectLine2} />
      
      {/* 题目卡片 */}
      <div className={styles.questionCard} key={question.id}>
        <div className={styles.questionNumber}>Q{state.currentQuestion + 1}</div>
        <p className={styles.questionText}>{question.text}</p>
        
        <div className={styles.options}>
          {question.options.map((opt, i) => (
            <button
              key={i}
              className={`${styles.option} ${selectedIndex === i ? styles.selected : ''} ${selectedIndex !== null && selectedIndex !== i ? styles.faded : ''} ${hoveredIndex === i ? styles.hovered : ''}`}
              onClick={() => handleSelect(opt, i)}
              onMouseEnter={() => setHoveredIndex(i)}
              onMouseLeave={() => setHoveredIndex(null)}
            >
              <span className={styles.optionLetter}>{String.fromCharCode(65 + i)}</span>
              <span className={styles.optionText}>{opt.text}</span>
              <span className={styles.optionArrow}>→</span>
            </button>
          ))}
        </div>
      </div>

      {/* 底部装饰线 */}
      <div className={styles.bottomLines}>
        <div className={styles.line1} />
        <div className={styles.line2} />
      </div>
    </div>
  );
}
